const code_type = { // 점검 방식 - 규칙이 type 이다
	'1' : 'Regex', '2' : 'SSDEEP', '3' : 'Hash(MD5)', '4' : 'URL'
}
const WSFINDER_CODE_TYPE = { // 점검 방식 - 규칙이 type 이다
	'1' : 'Regex', '2' : 'SSDEEP', '3' : 'Hash(MD5)', '4' : 'URL'
}

const code_category = { // 구분 / 분류
	1 : 'Unclassified', 2 : 'WebShell', 3 : 'SpamMail', 4 : 'FileManager', 5 : 'RansomeWare', 6 : 'Malware'
}
const code_ext = {
	1 : 'Unclassified', 2 : 'CGI Executable', 3 : 'JSP/WAR', 4 : 'NodeJS', 5 : 'ASP/ASPX', 6 : 'PHP'
}

const WMDS_TYPE = {
	U : 'URL', S : 'String', R : 'Regex', M : 'MD5'
}

const WMDS_LEVEL_PATTERN = {
	H : 'Danger', W : 'Warning', N : 'Caution', S : 'Suspicion'
}
const WMDS_LEVEL = (x, i18n='EN') => {
  let rs = '-'
  if(i18n == 'EN') {
    switch (x) {
      case 'H':
      case 'W':
      case 'N': rs = 'high'; break;
      case 'S': rs = 'medium'; break;
    }
    return rs
  } else if(i18n == 'KO') {
    switch (x) {
      case 'H':
      case 'W':
      case 'N': rs = '상'; break;
      case 'S': rs = '중'; break;
    }
    return rs
  }
}
const WMDS_PATTRN_LEVEL = {
	H : 'Danger', W : 'Warning', N : 'Caution', S : 'Suspicion'
}

const agent_forgery = {
	rename : 'Rename', create : 'Add', delete : 'Delete', modified : 'Modified'
}

// 수정시 매니저, 파트너도 수정해야 함
const BOARD_TYPE = {
  'wsf' : 'WSFinder',
  'wsfinder' : 'WSFinder',
  'wmds' : 'WMDS',
  'webcastle' : 'WEBCastle',
  'castle' : 'WEBCastle',
  'wfdetect' : 'WFDetector',
  'wfdetector' : 'WFDetector',
  'etc' : 'Etc',
  'Etc' : 'Etc',
  'Release' : 'Release',
  'release' : 'Release',
}

const DEFAULT_OPT = {
  perPage: 15, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {}
}

const WMDS_INSPECT_STATUS = {
  0 : 'wait',
  1 : 'ready',
  2 : 'running',
  3 : 'quit',
}


const timezone = [
  { value : -720, origin_value : "-12", name : "(GMT-12:00) International Date Line West" },
  { value : -660, origin_value : "-11", name : "(GMT-11:00) Midway Island, Samoa" },
  { value : -600, origin_value : "-10", name : "(GMT-10:00) Hawaii" },
  { value : -540, origin_value : "-9", name : "(GMT-09:00) Alaska" },
  { value : -480, origin_value : "-8", name : "(GMT-08:00) Pacific Time (US & Canada)" },
  { value : -420, origin_value : "-7", name : "(GMT-07:00) Arizona" },
  { value : -360, origin_value : "-6", name : "(GMT-06:00) Central America" },
  { value : -300, origin_value : "-5", name : "(GMT-05:00) Bogota, Lima, Quito, Rio Branco" },
  { value : -240, origin_value : "-4", name : "(GMT-04:00) Atlantic Time (Canada)" },
  { value : -210, origin_value : "-3.5", name : "(GMT-03:30) Newfoundland" },
  { value : -180, origin_value : "-3", name : "(GMT-03:00) Brasilia" },
  { value : -120, origin_value : "-2", name : "(GMT-02:00) Mid-Atlantic" },
  { value : -60, origin_value : "-1", name : "(GMT-01:00) Cape Verde Is." },
  { value : 0, origin_value : "0", name : "(GMT+00:00) Casablanca, Monrovia, Reykjavik" },
  { value : 60, origin_value : "1", name : "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
  { value : 120, origin_value : "2", name : "(GMT+02:00) Amman" },
  { value : 180, origin_value : "3", name : "(GMT+03:00) Kuwait, Riyadh, Baghdad" },
  { value : 210, origin_value : "3.5", name : "(GMT+03:30) Tehran" },
  { value : 240, origin_value : "4", name : "(GMT+04:00) Abu Dhabi, Muscat" },
  { value : 270, origin_value : "4.5", name : "(GMT+04:30) Kabul" },
  { value : 300, origin_value : "5", name : "(GMT+05:00) Yekaterinburg" },
  { value : 330, origin_value : "5.5", name : "(GMT+05:30) Sri Jayawardenapura" },
  { value : 345, origin_value : "5.75", name : "(GMT+05:45) Kathmandu" },
  { value : 360, origin_value : "6", name : "(GMT+06:00) Almaty, Novosibirsk" },
  { value : 390, origin_value : "6.5", name : "(GMT+06:30) Yangon (Rangoon)" },
  { value : 420, origin_value : "7", name : "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
  { value : 480, origin_value : "8", name : "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi" },
  { value : 540, origin_value : "9", name : "(GMT+09:00) Seoul" },
  { value : 570, origin_value : "9.5", name : "(GMT+09:30) Adelaide" },
  { value : 600, origin_value : "10", name : "(GMT+10:00) Brisbane" },
  { value : 660, origin_value : "11", name : "(GMT+11:00) Magadan, Solomon Is., New Caledonia" },
  { value : 720, origin_value : "12", name : "(GMT+12:00) Auckland, Wellington" },
  { value : 720, origin_value : "13", name : "(GMT+13:00) Nuku'alofa" },
]

const country = [
  { value : "AFG",  name : "Afghanistan" },
  { value : "ALB",  name : "Albania" },
  { value : "DZA",  name : "Algeria" },
  { value : "ASM",  name : "American Samoa" },
  { value : "AND",  name : "Andorra" },
  { value : "AGO",  name : "Angola" },
  { value : "AIA",  name : "Anguilla" },
  { value : "ATA",  name : "Antarctica" },
  { value : "ATG",  name : "Antigua and Barbuda" },
  { value : "ARG",  name : "Argentina" },
  { value : "ARM",  name : "Armenia" },
  { value : "ABW",  name : "Aruba" },
  { value : "AUS",  name : "Australia" },
  { value : "AUT",  name : "Austria" },
  { value : "AZE",  name : "Azerbaijan" },
  { value : "BHS",  name : "Bahamas" },
  { value : "BHR",  name : "Bahrain" },
  { value : "BGD",  name : "Bangladesh" },
  { value : "BRB",  name : "Barbados" },
  { value : "BLR",  name : "Belarus" },
  { value : "BEL",  name : "Belgium" },
  { value : "BLZ",  name : "Belize" },
  { value : "BEN",  name : "Benin" },
  { value : "BMU",  name : "Bermuda" },
  { value : "BTN",  name : "Bhutan" },
  { value : "BOL",  name : "Bolivia" },
  { value : "BIH",  name : "Bosnia and Herzegovina" },
  { value : "BWA",  name : "Botswana" },
  { value : "BRA",  name : "Brazil" },
  { value : "IOT",  name : "British Indian Ocean Territory" },
  { value : "VGB",  name : "British Virgin Islands" },
  { value : "BRN",  name : "Brunei" },
  { value : "BGR",  name : "Bulgaria" },
  { value : "BFA",  name : "Burkina Faso" },
  { value : "BDI",  name : "Burundi" },
  { value : "KHM",  name : "Cambodia" },
  { value : "CMR",  name : "Cameroon" },
  { value : "CAN",  name : "Canada" },
  { value : "CPV",  name : "Cape Verde" },
  { value : "CYM",  name : "Cayman Islands" },
  { value : "CAF",  name : "Central African Republic" },
  { value : "TCD",  name : "Chad" },
  { value : "CHL",  name : "Chile" },
  { value : "CHN",  name : "China" },
  { value : "CXR",  name : "Christmas Island" },
  { value : "CCK",  name : "Cocos Islands" },
  { value : "COL",  name : "Colombia" },
  { value : "COM",  name : "Comoros" },
  { value : "COK",  name : "Cook Islands" },
  { value : "CRI",  name : "Costa Rica" },
  { value : "HRV",  name : "Croatia" },
  { value : "CUB",  name : "Cuba" },
  { value : "CUW",  name : "Curacao" },
  { value : "CYP",  name : "Cyprus" },
  { value : "CZE",  name : "Czech Republic" },
  { value : "COD",  name : "Democratic Republic of the Congo" },
  { value : "DNK",  name : "Denmark" },
  { value : "DJI",  name : "Djibouti" },
  { value : "DMA",  name : "Dominica" },
  { value : "DOM",  name : "Dominican Republic" },
  { value : "TLS",  name : "East Timor" },
  { value : "ECU",  name : "Ecuador" },
  { value : "EGY",  name : "Egypt" },
  { value : "SLV",  name : "El Salvador" },
  { value : "GNQ",  name : "Equatorial Guinea" },
  { value : "ERI",  name : "Eritrea" },
  { value : "EST",  name : "Estonia" },
  { value : "ETH",  name : "Ethiopia" },
  { value : "FLK",  name : "Falkland Islands" },
  { value : "FRO",  name : "Faroe Islands" },
  { value : "FJI",  name : "Fiji" },
  { value : "FIN",  name : "Finland" },
  { value : "FRA",  name : "France" },
  { value : "PYF",  name : "French Polynesia" },
  { value : "GAB",  name : "Gabon" },
  { value : "GMB",  name : "Gambia" },
  { value : "GEO",  name : "Georgia" },
  { value : "DEU",  name : "Germany" },
  { value : "GHA",  name : "Ghana" },
  { value : "GIB",  name : "Gibraltar" },
  { value : "GRC",  name : "Greece" },
  { value : "GRL",  name : "Greenland" },
  { value : "GRD",  name : "Grenada" },
  { value : "GUM",  name : "Guam" },
  { value : "GTM",  name : "Guatemala" },
  { value : "GGY",  name : "Guernsey" },
  { value : "GIN",  name : "Guinea" },
  { value : "GNB",  name : "Guinea-Bissau" },
  { value : "GUY",  name : "Guyana" },
  { value : "HTI",  name : "Haiti" },
  { value : "HND",  name : "Honduras" },
  { value : "HKG",  name : "Hong Kong" },
  { value : "HUN",  name : "Hungary" },
  { value : "ISL",  name : "Iceland" },
  { value : "IND",  name : "India" },
  { value : "IDN",  name : "Indonesia" },
  { value : "IRN",  name : "Iran" },
  { value : "IRQ",  name : "Iraq" },
  { value : "IRL",  name : "Ireland" },
  { value : "IMN",  name : "Isle of Man" },
  { value : "ISR",  name : "Israel" },
  { value : "ITA",  name : "Italy" },
  { value : "CIV",  name : "Ivory Coast" },
  { value : "JAM",  name : "Jamaica" },
  { value : "JPN",  name : "Japan" },
  { value : "JEY",  name : "Jersey" },
  { value : "JOR",  name : "Jordan" },
  { value : "KAZ",  name : "Kazakhstan" },
  { value : "KEN",  name : "Kenya" },
  { value : "KIR",  name : "Kiribati" },
  { value : "XKX",  name : "Kosovo" },
  { value : "KWT",  name : "Kuwait" },
  { value : "KGZ",  name : "Kyrgyzstan" },
  { value : "LAO",  name : "Laos" },
  { value : "LVA",  name : "Latvia" },
  { value : "LBN",  name : "Lebanon" },
  { value : "LSO",  name : "Lesotho" },
  { value : "LBR",  name : "Liberia" },
  { value : "LBY",  name : "Libya" },
  { value : "LIE",  name : "Liechtenstein" },
  { value : "LTU",  name : "Lithuania" },
  { value : "LUX",  name : "Luxembourg" },
  { value : "MAC",  name : "Macau" },
  { value : "MKD",  name : "Macedonia" },
  { value : "MDG",  name : "Madagascar" },
  { value : "MWI",  name : "Malawi" },
  { value : "MYS",  name : "Malaysia" },
  { value : "MDV",  name : "Maldives" },
  { value : "MLI",  name : "Mali" },
  { value : "MLT",  name : "Malta" },
  { value : "MHL",  name : "Marshall Islands" },
  { value : "MRT",  name : "Mauritania" },
  { value : "MUS",  name : "Mauritius" },
  { value : "MYT",  name : "Mayotte" },
  { value : "MEX",  name : "Mexico" },
  { value : "FSM",  name : "Micronesia" },
  { value : "MDA",  name : "Moldova" },
  { value : "MCO",  name : "Monaco" },
  { value : "MNG",  name : "Mongolia" },
  { value : "MNE",  name : "Montenegro" },
  { value : "MSR",  name : "Montserrat" },
  { value : "MAR",  name : "Morocco" },
  { value : "MOZ",  name : "Mozambique" },
  { value : "MMR",  name : "Myanmar" },
  { value : "NAM",  name : "Namibia" },
  { value : "NRU",  name : "Nauru" },
  { value : "NPL",  name : "Nepal" },
  { value : "NLD",  name : "Netherlands" },
  { value : "ANT",  name : "Netherlands Antilles" },
  { value : "NCL",  name : "New Caledonia" },
  { value : "NZL",  name : "New Zealand" },
  { value : "NIC",  name : "Nicaragua" },
  { value : "NER",  name : "Niger" },
  { value : "NGA",  name : "Nigeria" },
  { value : "NIU",  name : "Niue" },
  { value : "PRK",  name : "North Korea" },
  { value : "MNP",  name : "Northern Mariana Islands" },
  { value : "NOR",  name : "Norway" },
  { value : "OMN",  name : "Oman" },
  { value : "PAK",  name : "Pakistan" },
  { value : "PLW",  name : "Palau" },
  { value : "PSE",  name : "Palestine" },
  { value : "PAN",  name : "Panama" },
  { value : "PNG",  name : "Papua New Guinea" },
  { value : "PRY",  name : "Paraguay" },
  { value : "PER",  name : "Peru" },
  { value : "PHL",  name : "Philippines" },
  { value : "PCN",  name : "Pitcairn" },
  { value : "POL",  name : "Poland" },
  { value : "PRT",  name : "Portugal" },
  { value : "PRI",  name : "Puerto Rico" },
  { value : "QAT",  name : "Qatar" },
  { value : "COG",  name : "Republic of the Congo" },
  { value : "REU",  name : "Reunion" },
  { value : "ROU",  name : "Romania" },
  { value : "RUS",  name : "Russia" },
  { value : "RWA",  name : "Rwanda" },
  { value : "BLM",  name : "Saint Barthelemy" },
  { value : "SHN",  name : "Saint Helena" },
  { value : "KNA",  name : "Saint Kitts and Nevis" },
  { value : "LCA",  name : "Saint Lucia" },
  { value : "MAF",  name : "Saint Martin" },
  { value : "SPM",  name : "Saint Pierre and Miquelon" },
  { value : "VCT",  name : "Saint Vincent and the Grenadines" },
  { value : "WSM",  name : "Samoa" },
  { value : "SMR",  name : "San Marino" },
  { value : "STP",  name : "Sao Tome and Principe" },
  { value : "SAU",  name : "Saudi Arabia" },
  { value : "SEN",  name : "Senegal" },
  { value : "SRB",  name : "Serbia" },
  { value : "SYC",  name : "Seychelles" },
  { value : "SLE",  name : "Sierra Leone" },
  { value : "SGP",  name : "Singapore" },
  { value : "SXM",  name : "Sint Maarten" },
  { value : "SVK",  name : "Slovakia" },
  { value : "SVN",  name : "Slovenia" },
  { value : "SLB",  name : "Solomon Islands" },
  { value : "SOM",  name : "Somalia" },
  { value : "ZAF",  name : "South Africa" },
  { value : "KOR",  name : "South Korea" },
  { value : "SSD",  name : "South Sudan" },
  { value : "ESP",  name : "Spain" },
  { value : "LKA",  name : "Sri Lanka" },
  { value : "SDN",  name : "Sudan" },
  { value : "SUR",  name : "Suriname" },
  { value : "SJM",  name : "Svalbard and Jan Mayen" },
  { value : "SWZ",  name : "Swaziland" },
  { value : "SWE",  name : "Sweden" },
  { value : "CHE",  name : "Switzerland" },
  { value : "SYR",  name : "Syria" },
  { value : "TWN",  name : "Taiwan" },
  { value : "TJK",  name : "Tajikistan" },
  { value : "TZA",  name : "Tanzania" },
  { value : "THA",  name : "Thailand" },
  { value : "TGO",  name : "Togo" },
  { value : "TKL",  name : "Tokelau" },
  { value : "TON",  name : "Tonga" },
  { value : "TTO",  name : "Trinidad and Tobago" },
  { value : "TUN",  name : "Tunisia" },
  { value : "TUR",  name : "Turkey" },
  { value : "TKM",  name : "Turkmenistan" },
  { value : "TCA",  name : "Turks and Caicos Islands" },
  { value : "TUV",  name : "Tuvalu" },
  { value : "VIR",  name : "U.S. Virgin Islands" },
  { value : "UGA",  name : "Uganda" },
  { value : "UKR",  name : "Ukraine" },
  { value : "ARE",  name : "United Arab Emirates" },
  { value : "GBR",  name : "United Kingdom" },
  { value : "USA",  name : "United States" },
  { value : "URY",  name : "Uruguay" },
  { value : "UZB",  name : "Uzbekistan" },
  { value : "VUT",  name : "Vanuatu" },
  { value : "VAT",  name : "Vatican" },
  { value : "VEN",  name : "Venezuela" },
  { value : "VNM",  name : "Vietnam" },
  { value : "WLF",  name : "Wallis and Futuna" },
  { value : "ESH",  name : "Western Sahara" },
  { value : "YEM",  name : "Yemen" },
  { value : "ZMB",  name : "Zambia" },
  { value : "ZWE",  name : "Zimbabwe" },
]

const service = [
  { name : "Basic", value : 0 },
  { name : "Pro", value : 0 },
  { name : "Premium", value : 0 }
];

const service_name = [
  "Basic",
  "Pro",
  "Premium",
];

const language = [
  { value : "EN",  name : "English" },
  { value : "KO",  name : "Korean" },
]

const timezone_default =  { value : 540, origin_value : "9", name : "(GMT+09:00) Seoul" }
const service_default = service[0];
const country_default = "South Korea";
const language_default = "Korean";
const is_del_text = [ "Enable", "Disable", ]

const permissions_user = ['Monitor', 'User', 'Billing', 'Owner',];

const is_del_value = {
  Enable : false,
  Disable : true
}

const WAF_LEVEL = [1, 2, 3, 4]
const WAF_MODE = ['Off', 'DetectionOnly', 'On'];
const WAF_MODE_OPTION = [
  { text : 'Off', value : 0 },
  { text : 'DetectionOnly', value : 1 },
  { text : 'On', value : 2 }
]

const WAF_MODE_OPTION_KO= [
  { text : '미사용', value : 0 },
  { text : '탐지모드', value : 1 },
  { text : '차단모드', value : 2 }
]

const WAF_MODE_OPTION_EN = [
  { text : 'Off', value : 0 },
  { text : 'DetectionOnly', value : 1 },
  { text : 'On', value : 2 }
]

const WAF_MODE_OFF = { TEXT : 'Off', VALUE : 0 };
const WAF_MODE_DETECTIONONLY = { TEXT : 'DetectionOnly', VALUE : 1 };
const WAF_MODE_ON = { TEXT : 'On', VALUE : 2 };
const WAF_MODE_CUSTOM = { TEXT : 'Custom', VALUE : 3 };

const TEXT_COLORS =  [
  "text-primary",
  "text-secondary",
  "text-success",
  "text-warning",
  "text-danger",
  "text-info",
  "text-light",
  "text-dark"
]

const COLORS =  [
  "primary",
  "secondary",
  "success",
  "warning",
  "danger",
  "info",
  "light",
  "dark"
]

const WAF_MIME_TYPE = [

  'text/css',
  'text/csv',
  'text/html',
  'text/calendar',
  'text/javascript',

  'application/x-abiword',
  'application/octet-stream',
  'application/vnd.amazon.ebook',
  'application/octet-stream',
  'application/x-bzip',
  'application/x-bzip2',
  'application/x-csh',
  'application/java-archive',
  'application/msword',
  'application/epub+zip',
  'application/json',
  'application/vnd.apple.installer+xml',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',

  'application/ogg',
  'application/pdf',
  'application/vnd.ms-powerpoint',
  'application/x-rar-compressed',
  'application/rtf',
  'application/x-sh',
  'application/x-shockwave-flash',
  'application/x-tar',
  'application/x-font-ttf',
  'application/vnd.visio',
  'application/x-font-woff',
  'application/xhtml+xml',
  'application/vnd.ms-excel',
  'application/xml',
  'application/vnd.mozilla.xul+xml',
  'application/zip',
  'application/x-7z-compressed',

  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'image/gif',
  'image/x-icon',
  'image/jpeg',

  'audio/x-wav',
  'audio/webm',
  'audio/ogg',
  'audio/midi',

  'video/webm',
  'video/ogg',
  'video/3gpp',
  'video/3gpp2',
  'video/mpeg',
  'video/x-msvideo',

  'audio/3gpp',
  'audio/3gpp2',
  'audio/aac',

]

const WAF_SEVERITY_TO_COLOR = (x, mode='hex') => {
  let rs = '#000000'
  if(mode == 'hex') {

    switch (Number(x)) {
      case (x > 6) : rs = 'dark'; break;
      case 6: rs = '#22dc6d'; break; // primary
      case 5: rs = '#007bff'; break; // primary
      case 4: rs = '#18a2b8'; break; // info
      case 3: rs = '#ffc107'; break; // yellow(light)
      case 2: rs = '#ff7f27'; break; // orange(warning)
      case 1: rs = '#dc3644'; break; // danger
      case 0: rs = '#ff0016'; break; // more high then danger
    }
    return rs
  }

  if(mode == 'variant') {
    switch (Number(x)) {
      case (x > 6) : rs = 'dark'; break;
      case 6: rs = 'success'; break;
      case 5: rs = 'info'; break;
      case 4: rs = 'primary'; break;
      case 3: rs = 'outline-warning'; break;
      case 2: rs = 'outline-danger'; break;
      case 1: rs = 'warning'; break;
      case 0: rs = 'danger'; break;
      default:
        rs = 'outline-secondary';
    }
    return rs
  }

}

const WAF_SEVERITY_TO_COLOR_EASY = (x, mode='hex') => {
  let rs = '#000000'
  if(mode == 'hex') {

    switch (Number(x)) {
      case (Number(x) > 6):
      case -1:
      case 6:
      case 5:
      case 4: rs = '#b1d43b'; break;
      case 3:
      case 2: rs = '#fdb92e'; break;
      case 1:
      case 0: rs = '#e71e07'; break;

    }
    return rs
  }

  if(mode == 'variant') {
    switch (Number(x)) {
      case (Number(x) > 6):
      case -1: rs = 'light'; break;
      case 6:
      case 5:
      case 4: rs = 'secondary'; break;
      case 3:
      case 2: rs = 'warning'; break;
      case 1:
      case 0: rs = 'danger'; break;
      default:
        rs = 'dark';
    }
    return rs
  }

}

const WAF_LEVEL_TO_COLOR = (x) => {
  let rs = 'light'

  switch (Number(x)) {
    case (x > 6) : rs = 'dark'; break;
    case 4: rs = 'danger'; break;
    case 3: rs = 'warning'; break;
    case 2: rs = 'outline-danger'; break;
    case 1: rs = 'outline-warning'; break;
  }
  return rs

}

const WAF_MODE_TO_COLOR = (x, type='') => {
  let rs = '-'

  if(type == 'hex') {
    switch (x.toString().toLowerCase()) {
      case '2':
      case 'On':
      case 'on': rs = '#E94C3D'; break;
      case '1':
      case 'DetectionOnly':
      case 'detectiononly': rs = '#FEB019'; break;
      case '0':
      case 'Off':
      case 'off': rs = '#19B99A'; break;
    }
    return rs
  }

  switch (x.toString().toLowerCase()) {
    case '2':
    case 'On':
    case 'on': rs = 'danger'; break;
    case '1':
    case 'DetectionOnly':
    case 'detectiononly': rs = 'warning'; break;
    case '0':
    case 'Off':
    case 'off': rs = 'light'; break;
  }
  return rs

}

const WAF_SEVERITY_DESC_TO_COLOR = (x, i18n='EN') => {
  let rs = '#000000'
  if(i18n == 'EN') {
    switch (x) {
      case 'Info': rs = '#22dc6d'; break;
      case 'Notice': rs = '#007bff'; break;
      case 'Warning': rs = '#18a2b8'; break;
      case 'Error': rs = '#ffc107'; break;
      case 'Critical': rs = '#ff7f27'; break;
      case 'Alert': rs = '#dc3644'; break;
      case 'Emergency': rs = '#ff0016'; break;
    }
    return rs
  } else if(i18n == 'KO') {
    switch (x) {
      case '정보': rs = '#22dc6d'; break;
      // case '정보': rs = '#22dc6d'; break;
      case '주의': rs = '#18a2b8'; break;
      case '에러': rs = '#ffc107'; break;
      case '치명적': rs = '#ff7f27'; break;
      case '경계': rs = '#dc3644'; break;
      case '긴급': rs = '#ff0016'; break;
    }
    return rs
  }
}

const WMDS_LEVEL_TO_COLOR = (x) => {
  return WAF_SEVERITY_TO_COLOR(x)
}

const WF_LEVEL_TO_COLOR = (x) => {
  return WAF_SEVERITY_TO_COLOR(x)
}

const WSF_LEVEL_TO_COLOR = (x, mode='hex') => {
  return WAF_SEVERITY_TO_COLOR(x, mode)
}

const WAF_MODE_I18N = (x, i18n='EN') => {
  let rs = '-'

  switch (x.toString().toLowerCase()) {
    case '2':
    case 'On':
    case 'on': rs = i18n == 'EN' ? 'Block' : ( i18n == 'JP' ? 'Block' : '차단');break;
    case '1':
    case 'DetectionOnly':
    case 'detectiononly': rs = i18n == 'EN' ? 'DetectionOnly' :(i18n == 'JP' ? 'DetectionOnly' : '탐지'); break;
    case '0':
    case 'Off':
    case 'off': rs = i18n == 'EN' ? 'Off' :(i18n == 'JP'? 'Off' : '미사용'); break;
  }
  return rs
}

const WAF_MODE_INTERFACE = (x) => {
  let rs = 0

  switch (x.toString().toLowerCase()) {
    case '2':
    case 'on': rs = 2; break;
    case '1':
    case 'detectiononly': rs = 1; break;
    case '0':
    case 'off': rs = 0; break;
  }
  return rs
}

const WAF_SEVERITY_TO_DESC = (x, i18n='EN') => {
  let rs = 'Custom'
  if(i18n == 'EN') {
    switch (Number(x)) {
      case (Number(x) > 6) : rs = 'Custom'; break;
      case 6: rs = 'Info'; break;
      case 5: rs = 'Notice'; break;
      case 4: rs = 'Warning'; break;
      case 3: rs = 'Error'; break;
      case 2: rs = 'Critical'; break;
      case 1: rs = 'Alert'; break;
      case 0: rs = 'Emergency'; break;
      case -1: rs = 'None'; break;
    }
    return rs
  } else if(i18n == 'KO') {
    switch (Number(x)) {
      case (Number(x) > 6) : rs = '사용자정의'; break;
      case 6: rs = '정보'; break;
      case 5: rs = '공지'; break;
      case 4: rs = '주의'; break;
      case 3: rs = '에러'; break;
      case 2: rs = '치명적'; break;
      case 1: rs = '경계'; break;
      case 0: rs = '긴급'; break;
      case -1: rs = '미정의'; break;
    }
    return rs
  }
}

// 3가지 로만 위험도 표시
const WAF_SEVERITY_TO_DESC_EASY = (x, i18n='EN') => {
  let rs = '-'
  if(i18n == 'EN') {
    switch (Number(x)) {
      case (Number(x) > 6):
      case -1:
      case 6:
      case 5:
      case 4: rs = 'Low'; break;
      case 3:
      case 2: rs = 'Medium'; break;
      case 1:
      case 0: rs = 'High'; break;

    }
    return rs
  } else if(i18n == 'KO') {
    switch (Number(x)) {
      case (Number(x) > 6):
      case -1:
      case 6:
      case 5:
      case 4: rs = '하'; break;
      case 3:
      case 2: rs = '중'; break;
      case 1:
      case 0: rs = '상'; break;

      // case 6: rs = '정보'; break;
      // case 5: rs = '공지'; break;
      // case 4: rs = '주의'; break;
      // case 3: rs = '에러'; break;
      // case 2: rs = '치명적'; break;
      // case 1: rs = '경계'; break;
      // case 0: rs = '긴급'; break;
      // case -1: rs = '미정의'; break;
    }
    return rs
  }
}

// 3가지 로만 위험도 표시
const WAF_SEVERITY_DESC_EASY_TO_NUMBER = (x, i18n='EN') => {
  let rs = 4
  if(i18n == 'EN') {
    switch (x) {
      case 'Low': rs = 4; break;
      case 'Medium': rs = 2; break;
      case 'High': rs = 0; break;

      // case (Number(x) > 6):
      // case -1:
      // case 6:
      // case 5:
      // case 4: rs = 'Low'; break;
      // case 3:
      // case 2: rs = 'Medium'; break;
      // case 1:
      // case 0: rs = 'High'; break;
    }
    return rs
  } else if(i18n == 'KO') {
    switch (x) {
      case '상': rs = 4; break;
      case '중': rs = 2; break;
      case '하': rs = 0; break;

      // case (Number(x) > 6):
      // case -1:
      // case 6:
      // case 5:
      // case 4: rs = '하'; break;
      // case 3:
      // case 2: rs = '중'; break;
      // case 1:
      // case 0: rs = '상'; break;

      // case 6: rs = '정보'; break;
      // case 5: rs = '공지'; break;
      // case 4: rs = '주의'; break;
      // case 3: rs = '에러'; break;
      // case 2: rs = '치명적'; break;
      // case 1: rs = '경계'; break;
      // case 0: rs = '긴급'; break;
      // case -1: rs = '미정의'; break;
    }
    return rs
  }
}

// 3가지 로만 위험도 표시
const WAF_SEVERITYS_EASY_TO_DESC = (x, i18n='EN') => {
  let rs = '-'

  if(i18n == 'EN') {
    switch (Number(x)) {
      case -1: rs = 'Low'; break;
      case 4: rs = 'Low'; break;
      case 2: rs = 'Medium'; break;
      case 0: rs = 'High'; break;
      default: rs = '-'; break;
    }
    return rs
  } else if(i18n == 'KO') {
    switch (Number(x)) {
      case -1: rs = '하'; break;
      case 4: rs = '하'; break;
      case 2: rs = '중'; break;
      case 0: rs = '상'; break;
      default: rs = '-'; break;
    }
    return rs
  }
}

let WSF_SCHEDULE = [
  { text : 'every day', value : 9 },
  { text : 'Sun', value : 0 },
  { text : 'Mon', value : 1 },
  { text : 'Tue', value : 2 },
  { text : 'Wed', value : 3 },
  { text : 'Thu', value : 4 },
  { text : 'Fri', value : 5 },
  { text : 'Sat', value : 6 },
]

let DAY_i18n = {
  'every day' : "매일",
  'Sun' : "일요일",
  'Mon' : "월요일",
  'Tue' : "화요일",
  'Wed' : "수요일",
  'Thu' : "목요일",
  'Fri' : "금요일",
  'Sat' : "토요일",
}

let WSF_SCHEDULE_i18n = {
  EN : [
    { text : 'every day', value : 9 },
    { text : 'Sun', value : 0 },
    { text : 'Mon', value : 1 },
    { text : 'Tue', value : 2 },
    { text : 'Wed', value : 3 },
    { text : 'Thu', value : 4 },
    { text : 'Fri', value : 5 },
    { text : 'Sat', value : 6 },
  ],
  KO : [
    { text : '매일', value : 9 },
    { text : '일요일', value : 0 },
    { text : '월요일', value : 1 },
    { text : '화요일', value : 2 },
    { text : '수요일', value : 3 },
    { text : '목요일', value : 4 },
    { text : '금요일', value : 5 },
    { text : '토요일', value : 6 },
  ],
  JP : [
    { text : 'every day', value : 9 },
    { text : 'Sun', value : 0 },
    { text : 'Mon', value : 1 },
    { text : 'Tue', value : 2 },
    { text : 'Wed', value : 3 },
    { text : 'Thu', value : 4 },
    { text : 'Fri', value : 5 },
    { text : 'Sat', value : 6 },
  ],
}

const REPORT_MONTH_ENG = [
  { text : "January", value : 1 },
  { text : "February", value : 2 },
  { text : "March", value : 3 },
  { text : "April", value : 4 },
  { text : "May", value : 5 },
  { text : "June", value : 6 },
  { text : "July", value : 7 },
  { text : "August", value : 8 },
  { text : "September", value : 9 },
  { text : "October", value : 10 },
  { text : "November", value : 11 },
  { text : "December", value : 12 },
]

const WAF_SEVERITYS = [-1, 0, 1, 2, 3, 4, 5, 6]

const WAF_SEVERITYS_EASY = [0, 2, 4]

const codes = {
  REPORT_MONTH_ENG,
  DEFAULT_OPT,
  WAF_MODE_OPTION,
  WAF_MODE_OFF,
  WAF_MODE_DETECTIONONLY,
  WAF_MODE_ON,
  WAF_LEVEL,
  WAF_MODE,
  permissions_user: permissions_user,
	agent_forgery : agent_forgery,
	WMDS_TYPE : WMDS_TYPE,

	code_category : code_category,
	code_type : code_type,
	code_ext : code_ext,
	WMDS_LEVEL : WMDS_LEVEL,
  WMDS_LEVEL_PATTERN : WMDS_LEVEL_PATTERN,
	BOARD_TYPE : BOARD_TYPE,

  language_default : language_default,
  timezone_default : timezone_default,
  country_default : country_default,
  service_default : service_default,
  service_name : service_name,

  country : country,
  timezone : timezone,
  language : language,

  is_del_text : is_del_text,
  is_del_value : is_del_value,

  // 신규 정의
  WMDS_INSPECT_STATUS,
  COLORS : COLORS,
  TEXT_COLORS : TEXT_COLORS,

  WAF_SEVERITY_TO_COLOR,
  WAF_SEVERITY_TO_COLOR_EASY,
  WAF_SEVERITY_TO_DESC,
  WAF_SEVERITY_TO_DESC_EASY,
  WAF_SEVERITYS_EASY_TO_DESC,
  WAF_SEVERITYS_EASY,
  WAF_SEVERITYS,
  WMDS_LEVEL_TO_COLOR,
  WF_LEVEL_TO_COLOR,


  WMDS_PATTRN_LEVEL,
  WSFINDER_CODE_TYPE,
  WSF_LEVEL_TO_COLOR,
  WSF_SCHEDULE,

  WAF_MODE_OPTION_KO,
  WAF_MODE_OPTION_EN,

  WSF_SCHEDULE_i18n,
  DAY_i18n,
  WAF_MODE_I18N,
  WAF_SEVERITY_DESC_TO_COLOR,
  WAF_LEVEL_TO_COLOR,
  WAF_MODE_TO_COLOR,
  WAF_MODE_INTERFACE,
  WAF_MIME_TYPE,
  WAF_MODE_CUSTOM,
  WAF_SEVERITY_DESC_EASY_TO_NUMBER
}

export default codes
